<template>
  <b-list-group class="the-navigation">
    <b-list-group-item
      v-for="(link, index) in links"
      :key="index"
      type="button"
      class="sidebar-nav-btn nav-border-left p-0 py-4"
      :active="isActive(link.routerName)"
      :data-test="`nav-item-${link.name}`"
    >
      <router-link
        class="router-link d-flex flex-column align-items-center"
        :to="{ name: link.routerName }"
      >
        <i
          :class="`nav-icon fal fa-${link.icon} mx-auto`"
        />
        <p
          class="mb-0 mt-2"
        >
          {{ link.name }}
        </p>
      </router-link>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { mapGetters } from 'vuex';
import urlHelper from '@/core/mixins/urlHelper';
import * as authenticationTypes from '@/modules/authentication/store/types';

export default {
  name: 'TheNavigation',
  mixins: [
    urlHelper,
  ],
  data() {
    return {
      links: [
        {
          icon: 'bullhorn',
          routerName: 'dashboard',
          name: 'Campaigns',
        },
        {
          icon: 'rectangle-history-circle-user',
          routerName: 'shareDashboard',
          name: 'Shared With Me',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('authentication', [
      authenticationTypes.GET_IS_ADMIN,
      authenticationTypes.GET_IS_ACCOUNT_MANAGER,
    ]),
  },
  methods: {
    isActive(name) {
      return this.$route.name === name;
    },
  },
  mounted() {
    if (this.GET_IS_ACCOUNT_MANAGER) {
      this.links.push(
        {
          icon: 'file-chart-column',
          routerName: 'reportsGeneratorDashboard',
          name: 'Reports',
        },
      );
    }
    if (this.GET_IS_ADMIN) {
      this.links.splice(2, 0, {
        icon: 'users-rectangle',
        routerName: 'selfServiceDashboard',
        name: 'Self Service',
      });
      this.links.push(
        {
          icon: 'file-code',
          routerName: 'templates',
          name: 'Templates',
        },
      );
    }
  },
};
</script>
<style lang="scss" scoped>
.the-navigation {
  color: $body-color;
  font-size: $font-size-base;
  line-height: 1rem;
  letter-spacing: 0.006rem;
  border-radius: 0;
  font-weight: 600;
}
.router-link {
  all: unset;
}
</style>
